<template>
  <v-container fluid tag="section">
      <base-material-dialog
        title='专利证证领取'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='400'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-5 py-5">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-menu
                      v-model="dataSelect"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                      hide-details="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          outlined
                          v-model="form.receiveTimeStr"
                          label="领证日期"
                          :rules="required"
                          readonly
                          v-bind="attrs"
                          hide-details="auto"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="zh-cn"
                        v-model="form.receiveTimeStr"
                        @input="dataSelect = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <base-marerial-user-select :other-users="[{ id: 100, mdUserId: 'WXVhbkRpYW5YaWFuZ011U2hlbkJhb0N', nameDeptStr: '系统用户(邮寄)', name: '系统用户'}]" :rules="required" :dense='false' :multiple='false' label='领证人' hide-details v-model="form.receiveUserId"></base-marerial-user-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-textarea rows='3' label="备注信息" hide-details='auto' outlined v-model="form.receiveDesc"></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/patent/index.js'
  import { ResetObject } from '@/utils/stringUtil.js'

  export default {
    name: 'PatentReceive',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        dataSelect: false,
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          id: '',
          receiveUserId: '',
          receiveTimeStr: '',
          receiveDesc: ''
        }
      }
    },
    methods: {
      save () {
        this.form.receiveTime = new Date(this.form.receiveTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
          this.form.status = 36
        } else {
          ResetObject(this.form)
        }
      },
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
